module.exports = __webpack_public_path__ + "resources/447a4771af76c48245a391e8f600ebc0.png";